import React from "react";
import { useTranslation } from "react-i18next";

import { ButtonGroup, IconButton, Button, HStack, Text, Badge } from "@chakra-ui/react";
import { FiChevronRight, FiChevronLeft, FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

const TablePagination = ({ currentPage, totalPages, totalItems, onPageChange, itemsName = "items", showTotalItems = true, showPageInfo = true }) => {
	const { t } = useTranslation();

	return (
		<HStack spacing={4} justify="space-between" w="100%">
			{showTotalItems && totalItems > 0 && (
				<HStack spacing={2}>
					<Badge variant="subtle" colorScheme="blue" fontSize="sm">
						{totalItems} {itemsName.toLowerCase()}
					</Badge>
					{showPageInfo && totalPages > 1 && (
						<Text fontSize="sm" color="gray.500">
							{t("table.page")} {currentPage} {t("table.of")} {totalPages}
						</Text>
					)}
				</HStack>
			)}

			{totalPages > 1 && (
				<ButtonGroup size="sm" variant="outline" spacing={2}>
					<IconButton icon={<FiChevronsLeft />} onClick={() => onPageChange(1)} isDisabled={currentPage === 1} aria-label="First page" />
					<IconButton icon={<FiChevronLeft />} onClick={() => onPageChange(currentPage - 1)} isDisabled={currentPage === 1} aria-label="Previous page" />
					<Button variant="solid" colorScheme="blue">
						{currentPage} of {totalPages}
					</Button>
					<IconButton icon={<FiChevronRight />} onClick={() => onPageChange(currentPage + 1)} isDisabled={currentPage === totalPages} aria-label="Next page" />
					<IconButton icon={<FiChevronsRight />} onClick={() => onPageChange(totalPages)} isDisabled={currentPage === totalPages} aria-label="Last page" />
				</ButtonGroup>
			)}
		</HStack>
	);
};

export default TablePagination;
